import {DeviceType} from '../../backend/enums/device-type';
import {translations} from '../../i18n/translations';

/**
 * Array with the available device types in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(deviceTypes[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const deviceTypes: Array<{translation: string; type: DeviceType}> = [
  {translation: translations.device_types[DeviceType.Desktop], type: DeviceType.Desktop},
  {translation: translations.device_types[DeviceType.Handset], type: DeviceType.Handset},
  {
    translation: translations.device_types[DeviceType.Laptop],
    type: DeviceType.Laptop,
  },
  {
    translation: translations.device_types[DeviceType.Tablet],
    type: DeviceType.Tablet,
  },
  {
    translation: translations.device_types[DeviceType.Unknown],
    type: DeviceType.Unknown,
  },
];
